module.exports = __webpack_public_path__ + "img/hok7.af784ccd.png";